"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onClientEntry = exports.wrapRootElement = exports.shouldUpdateScroll = exports.onRouteUpdate = void 0;
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
const React = __importStar(require("react"));
const react_1 = require("@emotion/react");
const create_emotion_cache_1 = __importDefault(require("./utils/create-emotion-cache"));
const onRouteUpdate = ({ location, prevLocation }) => {
    // find if we've got a hash defined - if we do - scroll to it
    const hash = window.gatsby_router_hash;
    const scrollTo = () => {
        const scrollOffset = -100;
        const elementToScrollTo = document.getElementById(hash.substr(1));
        if (elementToScrollTo) {
            const top = elementToScrollTo.getBoundingClientRect().top + window.scrollY + scrollOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };
    if (hash) {
        if (prevLocation?.pathname === location.pathname) {
            // Don't wait for transition if page is the same
            scrollTo();
        }
        else {
            setTimeout(() => {
                scrollTo();
            }, 300); // length of Framer exit transition
        }
        window.gatsby_router_hash = undefined;
    }
};
exports.onRouteUpdate = onRouteUpdate;
/*
* If the pathnames are the same, and there is a router hash, don't use in-built page scroll updating
* */
const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => !(prevRouterProps?.location?.pathname
    === routerProps?.location?.pathname && window.gatsby_router_hash);
exports.shouldUpdateScroll = shouldUpdateScroll;
const cache = (0, create_emotion_cache_1.default)();
// eslint-disable-next-line import/prefer-default-export
const wrapRootElement = ({ element }) => (
// eslint-disable-next-line react/jsx-filename-extension
React.createElement(react_1.CacheProvider, { value: cache }, element));
exports.wrapRootElement = wrapRootElement;
const onClientEntry = () => {
    // eslint-disable-next-line no-console
    console.log('%cdeveloped by audal labs. 💅💻', 'background-color: #251ad4; color: white; padding: 5px; font-weight: 600; border-radius: 4px; font-family: sans-serif;', 'https://audallabs.com');
};
exports.onClientEntry = onClientEntry;
//# sourceMappingURL=browser.js.map